export const en = {
  landing: {
    page_title: "Resources Around Me",
    find_support_across_canada: "Find support across Canada",
    page_description:
      "Choose a location to search for physical or virtual support programs and services available to kids, teens and young adults across Canada!",
    location_field_error: "Please enter a location.",
    use_current_location: "Use my current location",
  },
  searchType: {
    search_by_label: "Search by",
    search_tips_link: "Search tips",
    support_type__radio_label: "Support type",
    keyword__radio_label: "Keyword",
  },
  supportType: {
    dropdown_label: "Select support type",
    dropdown_default_value: "Select",
    narrow_down__dropdown_label: "Narrow down support type",
    narrow_down__dropdown_default_value: "Narrow it down",
    submit_button: "Find support programs and services",
    read_more_topic_text: "Learn more about supports for leaving care",
    read_more_topic_link: "https://kidshelpphone.ca/SupportsForLeavingCare",
  },
  searchByKeyword: {
    search_by_keyword_label: "Search by keyword",
    input_placeholder:"Example: youth shelter, clinic...",
    modal_title:
      "If you're experiencing suicidal thoughts, hope and help is available.",
    modal_description:
      "Kids Help Phone has a team of caring counsellors and crisis responders who can help. If you'd like to connect with us, you can:",
    modal_callus_btn: "Call us",
    modal_textus_btn: "Text us",
    modal_continue_search: "Continue to search results",
    submit_button: "Find support programs and services",
    keyword_1: "suicide",
    keyword_2: "kill myself",
    keyword_3: "i want to die",
  },
  searchPageHeader: {
    results: "Results",
    showing_keyword_results: "Showing keyword results for:",
    search_result_with: "Search result with",
    of: "of",
    items: "items",
    favourites: "favourites",
    edit_search: "Edit Search",
    add_to_favorite_tooltip: "Added to Favorites",
    removed_from_favorites_tooltip: "Removed from Favorites",
    go_to_fav: "Go to favorites marked list with",
    item: "item",
  },
  searchResult: {
    no_result_found: "No Result Found.",
  },
  searchItem: {
    add_to_favorite: "Add to your favourites list",
    addeed_to_favorite_wcag: "Added to your favourites list",
    remove_from_favorite_wcag:
      "Removed from your favourites list. Click to add it again.",
    result: "Result",
    of: "of",
    resource_type: "Resource type",
    website: "Visit Website",
    new_tab: "open in a new tab",
    view_more_details: "view more details",
    hotline: "Hotline",
    physical_location: "physical location",
    more_details: "More Details",
  },
  resourcedetails: {
    add_to_favorite: "Add to favourites",
    open_hours: "Open hours",
    remove_from_favourites: "Remove From Favourites",
    add_to_favorite_tooltip: "Added to Favorites",
    removed_from_favorites_tooltip: "Removed from Favorites",
    favourites: "favourites",
    back: "back",
    goto_fav_list: "Go to favorites marked list",
    call: "call",
    website: "Website",
    new_tab: "open in a new tab",
    about_us: "About us",
    details: "Details",
    cost: "Cost",
    age_limit: "Age limit",
    eligibility: "Eligibility",
    accessibility: "Accessibility",
    languages_offered: "Languages offered",
    wait_times: "Wait times",
    application_process: "Application process",
    documents_required: "Documents required",
    coverage_area: "Coverage area",
    visit_website: "Visit website",
    back_to_search_results: "Back to search results",
    get_directions: "Get directions",
  },
  ramFooter: {
    new_tab: "open in a new tab",
    search_tips: "Search tips",
    ram_faq: "Resources Around Me FAQ",
    what_you_think: "Tell us what you think of this tool",
    user_experience:
      "Please fill out this survey to let us know about your experience using this tool.",
  },
  map: {
    no_results: "Your search results has no physical locations",
  },
  loader: {
    title: "One moment while we find some resources for you...",
    searching_for: "Searching for",
    in: "in",
  },
  favoriteItem: {
    open_hours: "Open hours",
    phone: "Phone",
    details: "Details",
    website: "Website",
    cost: "Cost",
    age_limit: "Age limit",
    eligibility: "Eligibility",
    accessibility: "Accessibility",
    languages_offered: "Languages offered",
    wait_times: "Wait times",
    application_process: "Application process",
    documents_required: "Documents required",
    coverage_area: "Coverage area",
    remove_from_favourites: "Remove From Favourites",
    about: "About",
  },
  favorite: {
    email_sent: "Email has been sent.",
    error: "Error.",
    enter_emails: "Email Address cannot be blank.",
    invalid_captcha: "Invalid Captcha.",
    favourites: "Favourites",
    page_title: "Favourites",
    page_description:
      "This page shows the support programs and services you've added to your favourites list during your search. This list will not be saved if you leave this tool or close this tab/window.",
    email_list: "Email list",
    get_pdf: "Get PDF",
    clear_list: "Clear list",
    back_to_results: "Back to search results",
    no_result: "No Result found",
    modal_title: "Please enter your email",
    modal_description:
      "Email the resources you added to your favorites list to yourself or friends. Enter the email addresses separated by a comma in the box below. Then hit send.",
    modal_input_label: "Enter your email address",
    modal_email_input_placeholder: "Enter your email address",
    send_email: "Send email",
    removed_from_favorites_tooltip: "Removed from Favorites",
    close: "Close",
    back: "back",
  },
  dropdown: {
    clear_all_filter: "Clear all filter",
    resources_include: "Resources include",
    languages_offered: "Languages offered",
    communities_supported: "Communities supported",
    accessibility: "Accessibility",
    cost: "Cost",
  },
  filters: {
    resources_include: "Resources Include",
    languages_offered: "Languages offered",
    languages_offered_title: "Languages Offered",
    communities_supported: "Communities supported",
    accessibility: "Accessibility",
    cost: "Cost",
    show_all: "Show All",
    show_results: "Show Results",
    cancel: "Cancel",
    physical_location: "Physical Location",
    helplines: "Helplines",
    online_services: "Online Services",
    filter: "Filter",
    selected: "selected",
    close: "Close",
  },
  app: {
    error_description: "Something went wrong. Please try again.",
  },
  mapViewController: {
    list_view: "List View",
    map_view: "Map View",
    clear_filters: "Clear All Filters",
  },
};
